import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import RoleProtectedRoute from "../../router/RoleProtectedRoute";
import MantenimientoLayout from "./MantenimientoLayout";
import { MENU, MANTENIMIENTO_BASE, mantenimientoDefaultRoute } from "./config";

// Builds the /mantenimiento route tree from the nav config so the sub-menu and
// the routes never drift apart. Mirrors the POS route blocks (one app, flat
// sub-menu) wrapped in a RoleProtectedRoute.
const children: RouteObject[] = [
  { index: true, element: <Navigate to={mantenimientoDefaultRoute} replace /> },
  ...MENU.map((item) => ({ path: item.id, element: item.element })),
];

export const mantenimientoRoute: RouteObject = {
  path: MANTENIMIENTO_BASE,
  element: <RoleProtectedRoute restrictedRoles={["web_services"]} />,
  children: [
    {
      path: "",
      element: <MantenimientoLayout />,
      children,
    },
  ],
};
